function WpForm(params) {
    if(!params) {
        return;
    }
    this.$el = $(params.el);

    if(this.$el.length) {
        this.setDefaults(params);
        this.addListeners();
    }
}

WpForm.prototype.setDefaults = function(params) {
    this.inputClass = params.inputClass;
    this.errorClass = params.errorClass;
    this.errorLabelClass = params.errorLabelClass;
    
    this.dom = {
        $inputs: this.$el.find('.' +  this.inputClass),
        $dropdowns: this.$el.find('.select-input'),
        $serverError: this.$el.find(params.serverError),
        $submitButton: this.$el.find(params.submitButton),
        $digitInputs: this.$el.find('[data-digits]'),
    }

    this.$el.attr('novalidate', true);
}

WpForm.prototype.addListeners = function() {
    this.$el.on('submit', this.validateForm.bind(this));
    this.dom.$inputs.on('blur', this.onInputBlur.bind(this));
    this.dom.$inputs.on('change keyup', this.onInputChange.bind(this));
    this.dom.$dropdowns.on('change', this.onInputChange.bind(this));
    this.dom.$digitInputs.on('keypress', this.onDigitsInputChange.bind(this));
}

WpForm.prototype.onInputBlur = function(e) {
    e.stopPropagation();
    var $input = $(e.target);
    $input.addClass(this.inputClass + '--blured');

    if ($input.val()) {
        $input.addClass(this.inputClass + '--filled');
    } else {
        $input.removeClass(this.inputClass + '--filled');
    }
    this.validate($input);
}

WpForm.prototype.onInputChange = function(e) {
    var $input = $(e.target);

    
    var $input = $(e.target);

    if ($input.hasClass(this.inputClass + '--blured')) {
        this.validate($input);
    }
}

WpForm.prototype.onDigitsInputChange = function(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
       return false;

    return true;
}

// **********
// Validation
// **********
WpForm.prototype.validateForm = function (e) {
    e.preventDefault();
    var _this = this,
        errors = [],
        valid = true,
        $inputs = this.$el.find('input.' + this.inputClass + ':visible:enabled, .select-input');

    
    this.dom.$serverError.html('');

    $inputs.each(function (i, input) {
        var error = _this.validate($(input));
        if (error) {
            valid = false;
            errors.push('- ' + error);
        }
    });

    if (!valid) {
        alert(errors.join('\n'))
        return false;
    } else {
        this.dom.$submitButton.attr('disabled', true);
        $.ajax({
            type: "POST",
            url: _this.$el.attr('action'),
            data: _this.$el.serialize(),
            success: function (data) {
                _this.dom.$submitButton.attr('disabled', false);
                if (data.IsSuccess) {
                    window.location.href = data.RedirectUrl;
                } else {
                    _this.dom.$serverError.html('<p>' + data.Error + '</p>');
                }
            }
        });
    }
};

WpForm.prototype.validate = function ($input) {
    var value = $input.val(),
        error = null;

    this.clearValidation($input);

    if ($input.attr('required') && !this.validateRequired($input, value)) {
        error = $input.data('required');
    } else if ($input.attr('type') === 'email' && value && !this.validateEmail(value)) {
        error = $input.data('invalid');
    } else if ($input.data('phone') && value && !this.validatePhone(value)) {
        error = $input.data('invalid');
    }
    
    if (error) {
        $input.parent()
            .addClass(this.errorClass)
            .append('<label class="' + this.errorLabelClass + '">' + error + '</label>');
    }
    
    return error;
};

WpForm.prototype.clearValidation = function ($input) {
    $input.parent()
        .removeClass(this.errorClass)
        .find('.' + this.errorLabelClass).remove();
};

WpForm.prototype.validateRequired = function ($input, value) {
    if ($input.is(':checkbox')) {
        return $input.is(':checked');
    }
    if ($input.is(':radio')) {
        if ($input.attr('name')) {
            return $('[name=' + $input.attr('name') + ']:checked').length;
        } else {
            return $input.is(':checked');
        }
    }
    return value !== undefined && value !== null && value.length > 0;
};

WpForm.prototype.validateEmail = function (value) {
    return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
};

WpForm.prototype.validatePhone = function (value) {
    return value.length === 10 && /^\d+$/.test(value);
};

new WpForm({
    el: '#wp-gated-content-form',
    inputClass: 'wp-gated-content-form__input',
    errorClass: 'wp-gated-content-form__error',
    errorLabelClass: 'wp-gated-content-form__error-label',
    serverError: '.wp-gated-content-form__server-error',
    submitButton: '.wp-gated-content-form__submit-button'
});

new WpForm({
    el: '#wp-lets-talk-form',
    inputClass: 'wp-lets-talk-form__input',
    errorClass: 'wp-lets-talk-form__error',
    errorLabelClass: 'wp-lets-talk-form__error-label',
    serverError: '.wp-lets-talk-form__server-error',
    submitButton: '.wp-lets-talk-form__submit-button'
});